import { Spin } from 'antd';
import React from 'react';

const CircularProgress = ({ style = {}, className = '' }) => (
    <div className={`loader ${className}`} style={style}>
        <Spin size="large" />
    </div>
);
export default CircularProgress;
